export default __webpack_public_path__ + "static/media/DSCN1663.e969d114.JPG";